"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var updateOrderButtonStyles = makeStyles_1.default(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return ({
        updateOrderButton: (_b = {
                borderRadius: '4px'
            },
            _b[breakpoints.down('xs')] = {
                marginTop: '10px',
            },
            _b),
    });
}, { name: 'Checkout4_UpdateOrderButton' });
exports.default = updateOrderButtonStyles;
